<template>
  <sitemap-view />
</template>

<script>
import SitemapView from "../../sitemap/SitemapView";
export default {
  components: {
    SitemapView,
  },
}
</script>

